module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_vm._v("Preserving eggs, circa 1940s. Louis Edward Nollau Nitrate Photographic Print Collection, University of Kentucky Libraries.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("The southern breakfast is symbolic of much that is distinctive and exemplary about food in the South.")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('big', [_c('big', [_vm._v("B")])], 1), _vm._v("ecause cows and chickens were abundant on southern farms, egg, milk, and cheese dishes were enjoyed often at the southern table. Most of the dishes in this chapter are breakfast fare, but the tasty combination also shows up in casseroles, soufflés, and sauces throughout southern contemporary and historical cuisine. No one has ruled that an omelet is good only at breakfast, and most certainly the other dishes can be served as main dishes, sides, or desserts. The tomato fricassee was an absolute delight. Although a fricassee is normally made with meat, and typically chicken, this rich gravy has been popular since the colonial era.")], 1), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("Frances Jewell McVey's Meat Soufflé, circa 1920s")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 cup ground cooked meat")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 eggs, separated")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 tablespoons butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 tablespoons flour")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 tablespoons diced onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("⅛ teaspoon paprika")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ cup milk")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("Preheat the oven to 350 degrees. Brown the meat in an ovenproof skillet over medium heat. Set the meat aside and discard the pan drippings. Beat the egg yolks in a separate bowl. Using an electric or hand mixer, whip the whites until they stand in soft peaks. In the same skillet, over medium to medium-low heat, melt the butter and add the flour. Stir until this mixture is slightly browned; add the onion, salt, and paprika. Stir to combine. Gradually add the milk and cook until smooth and thick, stirring frequently. Add the meat along with the beaten egg yolks and stir until combined. Remove the mixture from the heat and fold in the beaten egg whites gradually. Bake for 30 minutes or until firm and lightly browned. Loosen the edges with a spatula before serving.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("Cheese Soufflé")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("¼ cup sour cream")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("8 ounces Neufchâtel cheese")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("5 tablespoons honey")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("¼ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("Preheat the oven to 350 degrees. Heat the sour cream and cheese over low heat stirring until very smooth. Remove the cheese mixture from the heat, add the honey, and mix well. Separate the egg yolks from the whites. Mix the salt into the yolks in a small bowl and set aside. Using an electric or hand mixer, whip the egg whites until they are stiff but not dry. Add the yolks to the cheese and mix to combine. Fold in one-fourth of the egg whites at first to lighten the cheese and egg mixture; then gently fold in the rest. Fill four individual pastry cases or custard cups and bake for 25 minutes.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("Scrambled Eggs with Cottage Cheese")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("4 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ teaspoon salt or more to taste")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Pepper to taste")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("4 tablespoons milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ teaspoon baking soda")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("4 rounded tablespoons cottage cheese")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("Mix the eggs, salt, pepper, and milk. Scramble the mixture in a greased skillet over medium heat. Remove from heat, sprinkle the baking soda over the cottage cheese, and stir into the egg mixture. Serve immediately.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("Frances Jewell McVey's Tomatoes with Eggs, circa 1920s")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Bread crumbs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 to 3 large tomatoes, sliced ⅛ inch thick")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 to 3 tablespoons butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("4 to 5 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("Preheat the oven to 375 degrees. Pour a layer of bread crumbs into an 11 × 7-inch buttered baking dish, add a layer of sliced tomatoes, salt and pepper the slices, and repeat until the dish is full. Add another layer of bread crumbs and dot the top with butter pieces. Bake for 30 minutes total. After 20 minutes, break the eggs carefully over the top, without overlapping, and return the dish to the oven until the eggs are set, an additional 10 to 12 minutes, depending on how firm you like your eggs.")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_vm._v("Tomatoes and Eggs")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("Mary M. Peter's Tomato Fricassee, 1889")]), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 (14½-ounce) can diced tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 tablespoons butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("⅛ teaspoon pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ teaspoon chopped onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Pinch of baking soda")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 beaten eggs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Buttered toast")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("Combine the tomatoes, butter, salt, pepper, onion, and soda in a medium saucepan. Simmer for 15 minutes and add the eggs. Stir constantly and remove the mixture from the heat the moment it begins to thicken, pour it over buttered toast, and serve.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("Seaton Family's Cheese Omelet, circa 1880s")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_vm._v("Tomato Fricassee")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("8 ounces shredded cheddar cheese")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("6 to 8 very thin slices of bread, enough to cover the bottom of the baking dish")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("¼ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("⅛ teaspoon cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("⅛ teaspoon dry mustard")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 egg")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 cup milk or cream")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("Preheat the oven to 350 degrees. Butter an 11 × 7-inch baking dish and put a layer of cheese in it. Cover the cheese with slices of bread and add another layer of cheese. Season with the salt, cayenne pepper, and dry mustard. Mix the egg and milk and pour the mixture evenly over the bread and cheese. Bake 30 minutes or until the top begins to brown.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("Louise Ludlow Dudley's Omelet with Fine Herbs, 1876")]), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("5 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("4 ounces cheese, grated (cheddar or mozzarella works well)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("4 ounces bread crumbs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("¼ cup cream or ½ cup milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 tablespoons finely chopped onion")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("⅛ teaspoon pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon butter")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("Beat the eggs to combine, and mix in the cheese, bread crumbs, cream, onion, parsley, salt, and pepper. Melt the butter in a skillet over medium heat. Pour in the egg mixture and cook until the bottom browns slightly. Flip the omelet and cook the other side. Fold in half and serve.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("Lucy Hayes Breckinridge's Creamy Omelet, early 1900s")]), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon melted butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 tablespoons water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ teaspoon butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("⅛ teaspoon pepper")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("Beat the eggs until they are just mixed. Add the melted butter and the water. Melt the ½ teaspoon of butter in the pan and pour in the eggs. Turn the egg mixture toward the center as it becomes creamy. Season with salt and pepper and cook until it browns on the bottom. Fold the omelet in half and serve.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("Lucy Hayes Breckinridge's Stuffed Eggs, early 1900s")]), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_vm._v("Creamy Omelet and Stuffed Eggs")]), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Dash of red pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("⅛ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 teaspoons melted butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Few drops onion extract")]), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("Lucy Hayes Breckinridge's Plain Foamy Omelet, early 1900s")]), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 tablespoons water")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ teaspoon butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("¼ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("⅛ teaspoon pepper")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("Preheat the oven to 350 degrees. Separate the eggs and beat the whites and yolks separately. Using an electric or hand mixer, take care to beat the whites until they are frothy but not stiff. Add the water to the yolks and mix. Add the beaten whites to the yolk and water mixture. Preheat an ovenproof pan, melt the butter in it, and add the egg mixture. Brown the bottom of the omelet, add the salt and pepper, and bake it until the eggs have set, 5 to 10 minutes. Fold the omelet in half and serve.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("To Poach Eggs, 1881")]), _vm._v(" "), _vm._m(27), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("Combine roughly 8 cups of water and 1 tablespoon of vinegar in a heavy saucepan and bring it to a simmer. Break 1 egg at a time into a small bowl and slide into the water. Simmer 2 to 3 minutes or until the egg white is firm. Remove the egg with a slotted spoon onto a paper towel to dry. Repeat with other eggs.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("Cooper Family's Eggs Somerset, circa 1960s")]), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 cups crabmeat or lobster")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 stick butter")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ cup cream")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Dash of cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Dash of paprika")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Dash of nutmeg")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 eggs plus 6 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 tablespoons sherry")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 cup cream sauce (page 135)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Gruyere cheese, thinly sliced")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("Cook the crabmeat, butter, and salt for 3 minutes in a double boiler. Add the cream, cayenne, paprika, and nutmeg and heat thoroughly. Beat 3 of the eggs, add them, and cook until thickened. Just before removing this mixture from the heat, add the sherry. Pour the mixture into a casserole dish or, for individual servings, into 6 small pastry shells. Prepare the cream sauce. Poach the remaining 6 eggs (see the preceding recipe) and place one on top of each individual pastry shell or arrange them on top of the mixture in the casserole dish. Dot generously with the Gruyere cheese and cover with the cream sauce. Heat the broiler to 500 degrees and broil the mixture 3 to 5 minutes, or until it is brown and bubbling.")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "img"
  }, [_c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/p5.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "chaptertitle"
  }, [_c('b', [_vm._v("Egg and Cheese Dishes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "epi1"
  }, [_c('i', [_vm._v("—John Egerton")]), _vm._v(", Southern Food in History")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "body-text"
  }, [_c('i', [_vm._v("This dish is light and fluffy. Because the roux is so thick, the meat is distributed evenly throughout the soufflé. We used one-half pound of Kentucky ground bison breakfast sausage, but any ground meat would be good. Please note that ground meats such as turkey or chicken would require extra salt."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#ch1-fnr1",
      "id": "ch1-fn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("6 to 8 servings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "body-text"
  }, [_c('i', [_vm._v("Delightfully light and exceptionally creamy, this circa 1920s soufflé would make a nice, sweet accompaniment for brunch; it could even serve as a light dessert. This dish is a highly recommended treat that will surprise and impress guests. Once prepared, serve it immediately."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#ch1-fnr2",
      "id": "ch1-fn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("4 servings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "body-text"
  }, [_c('i', [_vm._v("These scrambled eggs are as creamy as French omelets: soft, flavorful, and melting in your mouth. The eggs would be terrific served over an English muffin or toast. Allot two eggs per person and adjust the amounts accordingly. The original recipe reads, “Neutralize the acid in the cheese with soda and stir into the egg, serve immediately.” It did not seem to affect the flavor of the dish, but we followed the instructions faithfully."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#ch1-fnr3",
      "id": "ch1-fn3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("2 servings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "body-text"
  }, [_c('i', [_vm._v("An interesting recipe from the early to mid twentieth century. Fresh summer tomatoes are the key to making this a moist, flavorful dish. Don't cook the eggs too long, or they will become hard; they will continue to cook briefly after being removed from the oven. The original recipe calls for moistening the dish with stock, but fresh summer tomatoes provide enough liquid."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#ch1-fnr4",
      "id": "ch1-fn4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("4 to 6 servings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "img"
  }, [_c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/9_1.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "body-text"
  }, [_c('i', [_vm._v("We fell in love with this 1889 recipe immediately. Mary M. Peter's cookbook includes recipes credited to various women, but this one is her own. The fricassee is a rich tomato gravy, and while Mary Peter specifies serving it over toast, it would be excellent over biscuits with broiled ham for a weekend brunch."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#ch1-fnr5",
      "id": "ch1-fn5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("4 servings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "body-text"
  }, [_c('i', [_vm._v("While the title of this recipe suggests a traditional omelet (cooked eggs folded around some sort of filling), that is not the case for this dish. This recipe calls for pouring a milk-and-egg mixture over very thinly sliced bread and cheese and then baking it in the oven. The result, more akin to a casserole, is delicious no matter what it is called."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#ch1-fnr6",
      "id": "ch1-fn6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("4 to 6 servings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "img"
  }, [_c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/11_1.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "body-text"
  }, [_c('i', [_vm._v("We halved the 1876 recipe, which called for 10 eggs. Honestly, we were probably just low on eggs, but it also seemed a little easier to manage a 5-egg omelet. Another option would be to divide the egg mixture and make individual omelets. The onion and parsley give this hearty omelet a great deal of flavor."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#ch1-fnr7",
      "id": "ch1-fn7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("2 to 3 servings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "body-text"
  }, [_c('i', [_vm._v("It seemed unlikely that a “creamy omelet” could be created using water, but this recipe did produce a fluffy and creamy omelet. Additional ingredients, such as cheese, cooked meat, or vegetables, although not in the original recipe, could be added right before the omelet is folded. Use a nonstick pan to make it easier to flip the omelet."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#ch1-fnr8",
      "id": "ch1-fn8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("1 to 2 servings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "body-text"
  }, [_c('i', [_vm._v("Like the deviled eggs found at family reunions and many holiday meals in the South, these are classic in that they contain red pepper—the spice that makes them devilish. These eggs, however, don't have the familiar mayonnaise or relish, but butter makes them rich and perhaps even more sinful. If you can't find onion extract, a teaspoon or more of finely chopped onion will work fine. The simple version is delicious, but the original recipe offers variations for serving—including frying")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "img"
  }, [_c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/14_1.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("3 servings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("Place the eggs in a saucepan of cold water and bring to a boil. Simmer for 30 minutes over medium to medium-high heat. Run cool water over the eggs and remove the shells. Let the eggs cool completely and cut them in half. Remove the yolks to a bowl and add the red pepper, salt, butter, and onion extract; combine these ingredients. Put portions of the mixture into the egg whites. The original recipe advises, “The eggs may be served thus with a plain white sauce, or put in the oven covered with breadcrumbs and white sauce, or the halves put together, dipped in breadcrumbs, diluted eggs, and breadcrumbs again, then fried.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#ch1-fnr9",
      "id": "ch1-fn9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "body-text"
  }, [_c('i', [_vm._v("Frothing the whites and then adding them to the yolks makes this omelet astonishingly light and fluffy. Cook in an ovenproof, nonstick pan to make it easier to remove the omelet after cooking."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#ch1-fnr10",
      "id": "ch1-fn10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("1 to 2 servings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "body-text"
  }, [_c('i', [_vm._v("The 1881 recipe does not call for vinegar, but the addition of 1 tablespoon or more to the poaching liquid will help the egg whites coagulate. Use a cup or small bowl to transfer the eggs gently into the water. These instructions are from the original recipe: “Have a pan boiling water; have the eggs carefully broken and slip them into the boiling water; let them remain till the whites are set, and take out with spoon; put in a dish and pour on some drawn butter.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#ch1-fnr11",
      "id": "ch1-fn11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "body-text"
  }, [_c('i', [_vm._v("This recipe, as indicated on the typed original, was a favorite of John Sherman Cooper and his wife, the former Lorraine Arnold Rowan. Cooking the initial egg mixture requires patience to allow it to thicken properly. This dish is comfort food, pure and simple. Enjoy eggs somerset with a thick piece of toast or a biscuit."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#ch1-fnr12",
      "id": "ch1-fn12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("6 servings")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d79414a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap1.vue
// module id = 84
// module chunks = 0